import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import { uniqueId } from 'lodash';

const Circle = ({ rating, value, setRating, id }) => {
  const isSelected = rating === value;
  const ariaLabel = isSelected
    ? t('rating.selected', {
        value,
      })
    : t('rating.not_selected', {
        value,
      });
  return (
    <>
      <label htmlFor={id}>
        <button
          type="button"
          className={classNames('Rating-circle', {
            'Rating-circle--selected': isSelected,
          })}
          onClick={() => setRating(value)}
          aria-label={ariaLabel}
        >
          {value}
        </button>
      </label>
      <input
        type="radio"
        id={id}
        name="rating"
        value={value}
        checked={isSelected}
        readOnly
      />
    </>
  );
};

const Rating = ({
  length = 10,
  rating,
  setRating,
  minText = t('rating.min'),
  maxText = t('rating.max'),
}) => {
  // creates an array containing the values from 1-length
  const range = useMemo(() => {
    return Array.from({ length }, (_, i) => {
      return { id: uniqueId('rating'), value: i + 1 };
    });
  }, [length]);

  return (
    <div className="Rating">
      <div className="Rating-circles">
        {range.map(({ id, value }) => (
          <Circle
            key={id}
            value={value}
            rating={rating}
            setRating={setRating}
            id={id}
          />
        ))}
      </div>
      <div className="Rating-text">
        <Text
          className="Rating-text--min"
          variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}
          component="div"
        >
          {minText}
        </Text>
        <Text
          className="Rating-text--max"
          variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}
          component="div"
        >
          {maxText}
        </Text>
      </div>
    </div>
  );
};

export default Rating;
